














import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import ContributionsGrid from "@/shared/components/contribution/ContributionsGrid.vue";

@Component ({
  components: {
    ContributionsGrid
  }
})
export default class RecentContributionsAll extends Vue {
  @Prop()
  page: number;

  @Prop()
  routeToPages: (page: number) => Location;
}
